import { useCallback, useState } from 'react';

export function useSoundEffect(soundEffect: string, volume?: number) {
    const [soundEffectAudio] = useState(new Audio(soundEffect));

    const play = useCallback(() => {
        soundEffectAudio.volume = volume ?? 1;
        soundEffectAudio.currentTime = 0;
        soundEffectAudio.play();
    }, [soundEffectAudio, volume]);

    const loop = useCallback(() => {
        play();
        soundEffectAudio.addEventListener('ended', play);
    }, [play, soundEffectAudio]);

    const endLoop = useCallback(() => {
        soundEffectAudio.removeEventListener('ended', play);
        soundEffectAudio.pause();
    }, [play, soundEffectAudio]);

    return { play, loop, endLoop };
}
